import type { estypes } from '@elastic/elasticsearch'

import { textSubtypes } from './utils'

export const publicTemplatesMapping = {
  noteId: {
    type: 'keyword',
    index: false,
  },
  organizationId: {
    type: 'keyword',
    index: false,
  },
  organizationDomain: {
    type: 'keyword',
    index: false,
  },
  parentNoteIdList: {
    type: 'keyword',
    index: false,
  },
  title: {
    type: 'text',
    ...textSubtypes,
  },
  content: {
    type: 'text',
    ...textSubtypes,
  },
  content_vector: {
    type: 'dense_vector',
    dims: 768,
    index: true,
    similarity: 'cosine',
  },
  content_vector_e5: {
    type: 'dense_vector',
    dims: 1024,
    index: true,
    similarity: 'cosine',
  },
  description: {
    type: 'text',
    ...textSubtypes,
  },
  description_vector: {
    type: 'dense_vector',
    dims: 768,
    index: true,
    similarity: 'cosine',
  },
  description_vector_e5: {
    type: 'dense_vector',
    dims: 1024,
    index: true,
    similarity: 'cosine',
  },
} satisfies Record<string, estypes.MappingProperty>
